@file:OptIn(InternalResourceApi::class)

package com.hyperether.goodjob.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/com.hyperether.goodjob.resources/"

public val Res.string.select_employee: StringResource by lazy {
      StringResource("string:select_employee", "select_employee", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 25272, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22068, 43),
      ))
    }

public val Res.string.select_industry: StringResource by lazy {
      StringResource("string:select_industry", "select_industry", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 25324, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22112, 59),
      ))
    }

public val Res.string.select_job_status: StringResource by lazy {
      StringResource("string:select_job_status", "select_job_status", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 25388, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22172, 49),
      ))
    }

public val Res.string.select_role: StringResource by lazy {
      StringResource("string:select_role", "select_role", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 25438, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22222, 35),
      ))
    }

public val Res.string.select_skill: StringResource by lazy {
      StringResource("string:select_skill", "select_skill", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 25478, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22258, 52),
      ))
    }

public val Res.string.select_team: StringResource by lazy {
      StringResource("string:select_team", "select_team", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 25607, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22367, 47),
      ))
    }

public val Res.string.select_team_or_user: StringResource by lazy {
      StringResource("string:select_team_or_user", "select_team_or_user", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 25543, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22311, 55),
      ))
    }

public val Res.string.select_your_workspace: StringResource by lazy {
      StringResource("string:select_your_workspace", "select_your_workspace", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 25663, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22415, 57),
      ))
    }

public val Res.string.selected: StringResource by lazy {
      StringResource("string:selected", "selected", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 25733, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22473, 28),
      ))
    }

public val Res.string.send_reset_link: StringResource by lazy {
      StringResource("string:send_reset_link", "send_reset_link", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 25766, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22502, 43),
      ))
    }

public val Res.string.september: StringResource by lazy {
      StringResource("string:september", "september", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 25834, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22546, 29),
      ))
    }

public val Res.string.set_new_password: StringResource by lazy {
      StringResource("string:set_new_password", "set_new_password", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 25864, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22576, 52),
      ))
    }

public val Res.string.set_up_workspace: StringResource by lazy {
      StringResource("string:set_up_workspace", "set_up_workspace", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 25925, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22629, 104),
      ))
    }

public val Res.string.set_weekly_hours: StringResource by lazy {
      StringResource("string:set_weekly_hours", "set_weekly_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 26038, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22734, 48),
      ))
    }

public val Res.string.settings: StringResource by lazy {
      StringResource("string:settings", "settings", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 26095, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22783, 28),
      ))
    }

public val Res.string.sign_in: StringResource by lazy {
      StringResource("string:sign_in", "sign_in", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 26214, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22886, 27),
      ))
    }

public val Res.string.sign_in_good_job: StringResource by lazy {
      StringResource("string:sign_in_good_job", "sign_in_good_job", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 26132, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22812, 48),
      ))
    }

public val Res.string.sign_in_with: StringResource by lazy {
      StringResource("string:sign_in_with", "sign_in_with", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 26185, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22861, 24),
      ))
    }

public val Res.string.site: StringResource by lazy {
      StringResource("string:site", "site", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 26666, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23290, 20),
      ))
    }

public val Res.string.site_added: StringResource by lazy {
      StringResource("string:site_added", "site_added", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 26242, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22914, 50),
      ))
    }

public val Res.string.site_contact_person: StringResource by lazy {
      StringResource("string:site_contact_person", "site_contact_person", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 26305, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22965, 55),
      ))
    }

public val Res.string.site_deleted: StringResource by lazy {
      StringResource("string:site_deleted", "site_deleted", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 26365, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23021, 56),
      ))
    }

public val Res.string.site_name: StringResource by lazy {
      StringResource("string:site_name", "site_name", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 26541, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23181, 29),
      ))
    }

public val Res.string.site_name_mandatory: StringResource by lazy {
      StringResource("string:site_name_mandatory", "site_name_mandatory", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 26426, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23078, 43),
      ))
    }

public val Res.string.site_name_required: StringResource by lazy {
      StringResource("string:site_name_required", "site_name_required", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 26474, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23122, 58),
      ))
    }

public val Res.string.site_updated: StringResource by lazy {
      StringResource("string:site_updated", "site_updated", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 26575, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23211, 56),
      ))
    }

public val Res.string.sites: StringResource by lazy {
      StringResource("string:sites", "sites", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 26640, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23268, 21),
      ))
    }

public val Res.string.skill: StringResource by lazy {
      StringResource("string:skill", "skill", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 26801, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23393, 21),
      ))
    }

public val Res.string.skill_required: StringResource by lazy {
      StringResource("string:skill_required", "skill_required", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 26691, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23311, 58),
      ))
    }

public val Res.string.skills: StringResource by lazy {
      StringResource("string:skills", "skills", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 26770, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23370, 22),
      ))
    }

public val Res.string.skip: StringResource by lazy {
      StringResource("string:skip", "skip", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 26831, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23415, 20),
      ))
    }

public val Res.string.sort_by: StringResource by lazy {
      StringResource("string:sort_by", "sort_by", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 26864, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23436, 27),
      ))
    }

public val Res.string.start_at: StringResource by lazy {
      StringResource("string:start_at", "start_at", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 26900, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23464, 28),
      ))
    }

public val Res.string.start_by_adding: StringResource by lazy {
      StringResource("string:start_by_adding", "start_by_adding", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 26929, 215),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23493, 255),
      ))
    }

public val Res.string.start_date: StringResource by lazy {
      StringResource("string:start_date", "start_date", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 27145, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23749, 34),
      ))
    }

public val Res.string.start_end_time: StringResource by lazy {
      StringResource("string:start_end_time", "start_end_time", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 27180, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23784, 114),
      ))
    }

public val Res.string.start_organizing: StringResource by lazy {
      StringResource("string:start_organizing", "start_organizing", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 27311, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23899, 68),
      ))
    }

public val Res.string.start_time: StringResource by lazy {
      StringResource("string:start_time", "start_time", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 27392, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23968, 34),
      ))
    }

public val Res.string.start_typing_address: StringResource by lazy {
      StringResource("string:start_typing_address", "start_typing_address", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 27423, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24003, 84),
      ))
    }

public val Res.string.status: StringResource by lazy {
      StringResource("string:status", "status", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 27666, 22),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24214, 22),
      ))
    }

public val Res.string.status_check: StringResource by lazy {
      StringResource("string:status_check", "status_check", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 27532, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24088, 36),
      ))
    }

public val Res.string.status_mandatory: StringResource by lazy {
      StringResource("string:status_mandatory", "status_mandatory", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 27573, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24125, 36),
      ))
    }

public val Res.string.status_required: StringResource by lazy {
      StringResource("string:status_required", "status_required", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 27610, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24162, 51),
      ))
    }

public val Res.string.step: StringResource by lazy {
      StringResource("string:step", "step", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 27807, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24343, 20),
      ))
    }

public val Res.string.step_description: StringResource by lazy {
      StringResource("string:step_description", "step_description", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 27689, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24237, 48),
      ))
    }

public val Res.string.step_title: StringResource by lazy {
      StringResource("string:step_title", "step_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 27742, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24286, 34),
      ))
    }

public val Res.string.steps: StringResource by lazy {
      StringResource("string:steps", "steps", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 27781, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24321, 21),
      ))
    }

public val Res.string.submit: StringResource by lazy {
      StringResource("string:submit", "submit", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 27832, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24364, 30),
      ))
    }

public val Res.string.subscribe: StringResource by lazy {
      StringResource("string:subscribe", "subscribe", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 27875, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24395, 29),
      ))
    }

public val Res.string.subscription: StringResource by lazy {
      StringResource("string:subscription", "subscription", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 27909, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24425, 36),
      ))
    }

public val Res.string.success: StringResource by lazy {
      StringResource("string:success", "success", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 27946, 23),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24462, 27),
      ))
    }

public val Res.string.sunday: StringResource by lazy {
      StringResource("string:sunday", "sunday", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 27970, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24490, 22),
      ))
    }

public val Res.string.support: StringResource by lazy {
      StringResource("string:support", "support", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 27997, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24513, 47),
      ))
    }

public val Res.string.take_picture: StringResource by lazy {
      StringResource("string:take_picture", "take_picture", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 28057, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24561, 40),
      ))
    }

public val Res.string.tap_to_upload_photo: StringResource by lazy {
      StringResource("string:tap_to_upload_photo", "tap_to_upload_photo", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 28094, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24602, 55),
      ))
    }

public val Res.string.task_completion_report: StringResource by lazy {
      StringResource("string:task_completion_report", "task_completion_report", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 28154, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24658, 62),
      ))
    }

public val Res.string.task_empty: StringResource by lazy {
      StringResource("string:task_empty", "task_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 28217, 330),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24721, 230),
      ))
    }

public val Res.string.task_title_error: StringResource by lazy {
      StringResource("string:task_title_error", "task_title_error", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 28548, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24952, 56),
      ))
    }

public val Res.string.team: StringResource by lazy {
      StringResource("string:team", "team", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 28969, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25301, 20),
      ))
    }

public val Res.string.team_added: StringResource by lazy {
      StringResource("string:team_added", "team_added", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 28617, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25009, 50),
      ))
    }

public val Res.string.team_deleted: StringResource by lazy {
      StringResource("string:team_deleted", "team_deleted", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 28676, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25060, 56),
      ))
    }

public val Res.string.team_members_linked: StringResource by lazy {
      StringResource("string:team_members_linked", "team_members_linked", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 28733, 147),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25117, 107),
      ))
    }

public val Res.string.team_required: StringResource by lazy {
      StringResource("string:team_required", "team_required", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 28881, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25225, 53),
      ))
    }

public val Res.string.teams: StringResource by lazy {
      StringResource("string:teams", "teams", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 28947, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25279, 21),
      ))
    }

public val Res.string.terms_of_service: StringResource by lazy {
      StringResource("string:terms_of_service", "terms_of_service", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 28990, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25322, 48),
      ))
    }

public val Res.string.thank_you_for_registering: StringResource by lazy {
      StringResource("string:thank_you_for_registering", "thank_you_for_registering", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 29043, 285),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25371, 233),
      ))
    }

public val Res.string.this_week: StringResource by lazy {
      StringResource("string:this_week", "this_week", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 29329, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25605, 29),
      ))
    }

public val Res.string.thursday: StringResource by lazy {
      StringResource("string:thursday", "thursday", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 29363, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25635, 28),
      ))
    }

public val Res.string.time: StringResource by lazy {
      StringResource("string:time", "time", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 29396, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25664, 20),
      ))
    }

public val Res.string.title: StringResource by lazy {
      StringResource("string:title", "title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 29417, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25685, 21),
      ))
    }

public val Res.string.today: StringResource by lazy {
      StringResource("string:today", "today", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 29486, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25754, 21),
      ))
    }

public val Res.string.today_schedule: StringResource by lazy {
      StringResource("string:today_schedule", "today_schedule", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 29439, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25707, 46),
      ))
    }

public val Res.string.total: StringResource by lazy {
      StringResource("string:total", "total", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 29508, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25776, 21),
      ))
    }

public val Res.string.transform: StringResource by lazy {
      StringResource("string:transform", "transform", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 29530, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25798, 73),
      ))
    }

public val Res.string.transparent_flexible: StringResource by lazy {
      StringResource("string:transparent_flexible", "transparent_flexible", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 29612, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25872, 96),
      ))
    }

public val Res.string.try_another_document: StringResource by lazy {
      StringResource("string:try_another_document", "try_another_document", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 29721, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25969, 84),
      ))
    }

public val Res.string.tuesday: StringResource by lazy {
      StringResource("string:tuesday", "tuesday", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 29826, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26054, 27),
      ))
    }

public val Res.string.unassigned: StringResource by lazy {
      StringResource("string:unassigned", "unassigned", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 29854, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26082, 34),
      ))
    }

public val Res.string.unexpected_error: StringResource by lazy {
      StringResource("string:unexpected_error", "unexpected_error", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 29897, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26117, 60),
      ))
    }

public val Res.string.unknown_error: StringResource by lazy {
      StringResource("string:unknown_error", "unknown_error", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 29974, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26178, 57),
      ))
    }

public val Res.string.unlimited_storage: StringResource by lazy {
      StringResource("string:unlimited_storage", "unlimited_storage", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 30048, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26236, 49),
      ))
    }

public val Res.string.unnamed_team: StringResource by lazy {
      StringResource("string:unnamed_team", "unnamed_team", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 30110, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26286, 36),
      ))
    }

public val Res.string.unselect_all: StringResource by lazy {
      StringResource("string:unselect_all", "unselect_all", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 30155, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26323, 36),
      ))
    }

public val Res.string.upcoming_jobs: StringResource by lazy {
      StringResource("string:upcoming_jobs", "upcoming_jobs", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 30196, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26360, 41),
      ))
    }

public val Res.string.upcoming_leaves: StringResource by lazy {
      StringResource("string:upcoming_leaves", "upcoming_leaves", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 30238, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26402, 43),
      ))
    }

public val Res.string.upcoming_tasks: StringResource by lazy {
      StringResource("string:upcoming_tasks", "upcoming_tasks", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 30282, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26446, 42),
      ))
    }

public val Res.string.update: StringResource by lazy {
      StringResource("string:update", "update", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 30535, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26647, 22),
      ))
    }

public val Res.string.update_contact: StringResource by lazy {
      StringResource("string:update_contact", "update_contact", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 30329, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26489, 42),
      ))
    }

public val Res.string.update_employee: StringResource by lazy {
      StringResource("string:update_employee", "update_employee", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 30380, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26532, 43),
      ))
    }

public val Res.string.update_job: StringResource by lazy {
      StringResource("string:update_job", "update_job", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 30440, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26576, 34),
      ))
    }

public val Res.string.update_site: StringResource by lazy {
      StringResource("string:update_site", "update_site", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 30483, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26611, 35),
      ))
    }

public val Res.string.upload_documents: StringResource by lazy {
      StringResource("string:upload_documents", "upload_documents", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 30570, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26670, 64),
      ))
    }

public val Res.string.upload_photos_of_completed_job: StringResource by lazy {
      StringResource("string:upload_photos_of_completed_job", "upload_photos_of_completed_job", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 30635, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26735, 86),
      ))
    }

public val Res.string.upload_profile_picture: StringResource by lazy {
      StringResource("string:upload_profile_picture", "upload_profile_picture", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 30722, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26822, 62),
      ))
    }

public val Res.string.upload_signature: StringResource by lazy {
      StringResource("string:upload_signature", "upload_signature", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 30781, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26885, 80),
      ))
    }

public val Res.string.use_contact_name: StringResource by lazy {
      StringResource("string:use_contact_name", "use_contact_name", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 30874, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26966, 68),
      ))
    }

public val Res.string.user: StringResource by lazy {
      StringResource("string:user", "user", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 31206, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27274, 20),
      ))
    }

public val Res.string.user_deleted: StringResource by lazy {
      StringResource("string:user_deleted", "user_deleted", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 30951, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27035, 56),
      ))
    }

public val Res.string.user_status_active: StringResource by lazy {
      StringResource("string:user_status_active", "user_status_active", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 31012, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27092, 34),
      ))
    }

public val Res.string.user_status_inactive: StringResource by lazy {
      StringResource("string:user_status_inactive", "user_status_inactive", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 31047, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27127, 40),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString4Resources(map: MutableMap<String, StringResource>) {
  map.put("select_employee", Res.string.select_employee)
  map.put("select_industry", Res.string.select_industry)
  map.put("select_job_status", Res.string.select_job_status)
  map.put("select_role", Res.string.select_role)
  map.put("select_skill", Res.string.select_skill)
  map.put("select_team", Res.string.select_team)
  map.put("select_team_or_user", Res.string.select_team_or_user)
  map.put("select_your_workspace", Res.string.select_your_workspace)
  map.put("selected", Res.string.selected)
  map.put("send_reset_link", Res.string.send_reset_link)
  map.put("september", Res.string.september)
  map.put("set_new_password", Res.string.set_new_password)
  map.put("set_up_workspace", Res.string.set_up_workspace)
  map.put("set_weekly_hours", Res.string.set_weekly_hours)
  map.put("settings", Res.string.settings)
  map.put("sign_in", Res.string.sign_in)
  map.put("sign_in_good_job", Res.string.sign_in_good_job)
  map.put("sign_in_with", Res.string.sign_in_with)
  map.put("site", Res.string.site)
  map.put("site_added", Res.string.site_added)
  map.put("site_contact_person", Res.string.site_contact_person)
  map.put("site_deleted", Res.string.site_deleted)
  map.put("site_name", Res.string.site_name)
  map.put("site_name_mandatory", Res.string.site_name_mandatory)
  map.put("site_name_required", Res.string.site_name_required)
  map.put("site_updated", Res.string.site_updated)
  map.put("sites", Res.string.sites)
  map.put("skill", Res.string.skill)
  map.put("skill_required", Res.string.skill_required)
  map.put("skills", Res.string.skills)
  map.put("skip", Res.string.skip)
  map.put("sort_by", Res.string.sort_by)
  map.put("start_at", Res.string.start_at)
  map.put("start_by_adding", Res.string.start_by_adding)
  map.put("start_date", Res.string.start_date)
  map.put("start_end_time", Res.string.start_end_time)
  map.put("start_organizing", Res.string.start_organizing)
  map.put("start_time", Res.string.start_time)
  map.put("start_typing_address", Res.string.start_typing_address)
  map.put("status", Res.string.status)
  map.put("status_check", Res.string.status_check)
  map.put("status_mandatory", Res.string.status_mandatory)
  map.put("status_required", Res.string.status_required)
  map.put("step", Res.string.step)
  map.put("step_description", Res.string.step_description)
  map.put("step_title", Res.string.step_title)
  map.put("steps", Res.string.steps)
  map.put("submit", Res.string.submit)
  map.put("subscribe", Res.string.subscribe)
  map.put("subscription", Res.string.subscription)
  map.put("success", Res.string.success)
  map.put("sunday", Res.string.sunday)
  map.put("support", Res.string.support)
  map.put("take_picture", Res.string.take_picture)
  map.put("tap_to_upload_photo", Res.string.tap_to_upload_photo)
  map.put("task_completion_report", Res.string.task_completion_report)
  map.put("task_empty", Res.string.task_empty)
  map.put("task_title_error", Res.string.task_title_error)
  map.put("team", Res.string.team)
  map.put("team_added", Res.string.team_added)
  map.put("team_deleted", Res.string.team_deleted)
  map.put("team_members_linked", Res.string.team_members_linked)
  map.put("team_required", Res.string.team_required)
  map.put("teams", Res.string.teams)
  map.put("terms_of_service", Res.string.terms_of_service)
  map.put("thank_you_for_registering", Res.string.thank_you_for_registering)
  map.put("this_week", Res.string.this_week)
  map.put("thursday", Res.string.thursday)
  map.put("time", Res.string.time)
  map.put("title", Res.string.title)
  map.put("today", Res.string.today)
  map.put("today_schedule", Res.string.today_schedule)
  map.put("total", Res.string.total)
  map.put("transform", Res.string.transform)
  map.put("transparent_flexible", Res.string.transparent_flexible)
  map.put("try_another_document", Res.string.try_another_document)
  map.put("tuesday", Res.string.tuesday)
  map.put("unassigned", Res.string.unassigned)
  map.put("unexpected_error", Res.string.unexpected_error)
  map.put("unknown_error", Res.string.unknown_error)
  map.put("unlimited_storage", Res.string.unlimited_storage)
  map.put("unnamed_team", Res.string.unnamed_team)
  map.put("unselect_all", Res.string.unselect_all)
  map.put("upcoming_jobs", Res.string.upcoming_jobs)
  map.put("upcoming_leaves", Res.string.upcoming_leaves)
  map.put("upcoming_tasks", Res.string.upcoming_tasks)
  map.put("update", Res.string.update)
  map.put("update_contact", Res.string.update_contact)
  map.put("update_employee", Res.string.update_employee)
  map.put("update_job", Res.string.update_job)
  map.put("update_site", Res.string.update_site)
  map.put("upload_documents", Res.string.upload_documents)
  map.put("upload_photos_of_completed_job", Res.string.upload_photos_of_completed_job)
  map.put("upload_profile_picture", Res.string.upload_profile_picture)
  map.put("upload_signature", Res.string.upload_signature)
  map.put("use_contact_name", Res.string.use_contact_name)
  map.put("user", Res.string.user)
  map.put("user_deleted", Res.string.user_deleted)
  map.put("user_status_active", Res.string.user_status_active)
  map.put("user_status_inactive", Res.string.user_status_inactive)
}
